__webpack_require__.p = "https://direct.chesshotel.com/_next/";